import { Spacer } from "../atoms/Atoms"
import React from "react"
import { HomeCard } from "./Home"
import L10n from "../../../lib/carrot-l10n"
import { ArrowLink } from "../atoms/links/ArrowLink"
import { H2 } from "@carrotfertility/carotene"
const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const UngroupedReadAndLearnModule = () => (
  <HomeCard halfWidth>
    <H2>Read + learn: Fertility basics</H2>
    <Spacer height={0.25} />
    <span className="publico-text fw4 lh-copy black-80">
      Brush up on the basics and read answers to common questions.
    </span>
    <Spacer height={1} />
    <ArrowLink to="/read/Fertility-basics">Read about fertility basics</ArrowLink>
    <ArrowLink to="/library">{l`client.home.browseAllTopics`}</ArrowLink>
  </HomeCard>
)

export default UngroupedReadAndLearnModule
